import { EGZOTechAgentService } from "./EGZOTechAgentService";

export class EGZOTechAgentManager {
    private agents: { name: string, modules: string[] }[];

    constructor(
        private agentService: EGZOTechAgentService
    ) {
        this.agents = [];
    }

    getAgent(agent: string) {
        return this.agents.find(v => v.name === agent);
    }

    getAgentWithModule(module: string) {
        const agent = this.agents.find(v => v.modules.indexOf(module) >= 0);

        return agent ? agent.name : null;
    }

    async addAgent(name: string) {
        const agent = { name, modules: [] };
        this.agents.push(agent);

        const response = await this.agentService.registry.request({
            ask: `/agent/${name}/modules`
        });

        try {
            agent.modules = JSON.parse(response.getPayload());
        }
        catch(ex) {
            console.log(ex);
        }
    }
}
